// ThemeContext — FORCE WHITE THEME ONLY (Premium v2 Ultra)

import { createContext, useContext } from "react";

const ThemeContext = createContext({
  theme: "light",
  toggleTheme: () => {}
});

export function ThemeProvider({ children }) {
  // No dark mode. No toggling. Always white.
  document.documentElement.classList.remove("dark-mode");
  document.documentElement.classList.add("light-mode");

  return (
    <ThemeContext.Provider value={{ theme: "light", toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
